import { render, staticRenderFns } from "./order-form.vue?vue&type=template&id=71e9c235&scoped=true&"
import script from "./order-form.vue?vue&type=script&lang=js&"
export * from "./order-form.vue?vue&type=script&lang=js&"
import style0 from "./order-form.vue?vue&type=style&index=0&id=71e9c235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e9c235",
  null
  
)

export default component.exports